import { createSonarSelector } from '@lib/selectors';
import { SonarObjectReference } from '@sonar-software/sonar-core';
import { useMemo } from 'react';
import { useOptimisticUpdate } from '../useOptimisticUpdate';
import { useSonarSelector } from '../useSonarSelector';

const mapSelector = createSonarSelector((state) => state.core.sonarObjects.byIdMap);

const emptyMap: Record<number, SonarObjectReference> = {};
const empty: SonarObjectReference = {
	context: {
		definition: '',
		notes: ''
	},
	ingestedBy: [],
	initiativeIds: [],
	linkedIntegrations: [],
	populatedBy: [],
	relatedCounts: {},
	salesforce: {},
	stakeholders: [],
	tagIds: [],
	users: []
};

/**
 * Subscribes to the shared state for a particular sonar object.
 * @param sonarObjectId The id of the sonar object to subscribe to.
 * @returns A {@link SonarObjectReference} instance for the provided id.
 */
export function useSonarObjectReference(sonarObjectId: number): SonarObjectReference {
	const { changes } = useOptimisticUpdate(sonarObjectId);

	const reference = useSonarSelector((state) => (mapSelector(state).data ?? emptyMap)[ sonarObjectId ] ?? empty);

	const result = useMemo(() => ({
		...reference,
		salesforce: {
			...reference.salesforce,
			...changes
		}
	}), [ changes, reference ]);

	return result;
}
